// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"2c142654","492":"41e7ba71","787":"f26a3337"}[chunkId] + ".chunk.js";
};